import { useEffect } from 'react';
import shallow from 'zustand/shallow';

import { useAsync, useGetQuery } from '../../../../lib/client/hooks';

import { useAcademicYear } from './index';

import * as services from '../services';
import * as TYPES from '../constants';

export function useListAcademicYear(params) {
  const { data, status, errorMessage, isIdle, refetch, isFetching } =
    useGetQuery({
      queryKey: params.queryKey || TYPES.FETCH_ACADEMIC_YEAR,
      queryFn: async () => {
        const response = await services.listAcademicYear(params);
        return response.data;
      },
    });

  return {
    data,
    status,
    errorMessage,
    isIdle,
    refetch,
    isFetching,
  };
}

export function useCreateAcademicYear() {
  const { execute, status, value, errorMessage, fieldErrors } = useAsync(
    services.createAcademicYear,
  );

  const [setResult] = useAcademicYear((state) => [state.setResult], shallow);

  useEffect(() => {
    if (status === 'resolved') {
      setResult(value.data);
    }
  }, [status]);

  async function create(payload) {
    try {
      await execute(payload);
    } catch (err) {
      console.error(err);
    }
  }

  return [create, status, errorMessage, fieldErrors];
}

export function useDeleteAcademicYears() {
  const { execute, status, value, errorMessage, fieldErrors } = useAsync(
    services.deleteAcademicYear,
  );

  async function remove(payload) {
    try {
      await execute(payload);
    } catch (err) {
      console.log(err);
      throw err;
    }
  }
  return [remove, status, value, errorMessage, fieldErrors];
}

export function useUpdateAcademicYear() {
  const { execute, status, value, errorMessage, fieldErrors } = useAsync(
    services.updateAcademicYear,
  );

  const [setResult] = useAcademicYear((state) => [state.setResult], shallow);

  useEffect(() => {
    if (status === 'resolved') {
      setResult(value.data);
    }
  }, [status]);

  async function update(payload) {
    try {
      await execute(payload);
    } catch (err) {
      console.error(err);
    }
  }

  return [update, status, errorMessage, fieldErrors];
}

export function useShowAcademicYear(id) {
  const { data, status, errorMessage, isIdle, refetch } = useGetQuery({
    queryKey: TYPES.FETCH_ACADEMIC_YEAR,
    queryFn: async () => {
      const response = await services.showAcademicYear(id);
      return response.data;
    },
  });

  return {
    data,
    status,
    errorMessage,
    isIdle,
    refetch,
  };
}
